import * as React from 'react';
import moment from 'moment';

export function prettyJSON(json) {
  // http://stackoverflow.com/questions/4810841/how-can-i-pretty-print-json-using-javascript
  const processedJSON = json.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  return processedJSON.replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+-]?\d+)?)/g, (match) => {
    // eslint-disable-next-line no-unused-vars
    let cls = 'number';
    if (/^"/.test(match)) {
      if (/:$/.test(match)) {
        cls = 'key';
      } else {
        cls = 'string';
      }
    } else if (/true|false/.test(match)) {
      cls = 'boolean';
    } else if (/null/.test(match)) {
      cls = 'null';
    }

    return <span className='${cls}'>${match}</span>;
  });
}

export function formatDate(date, showHoursAndMinutes = true) {
  const format = showHoursAndMinutes ? 'YYYY/MM/DD HH:mm:ss' : 'YYYY/MM/DD';
  return date ? moment(date).format(format) : undefined;
}

const simReplacementFaultTypes = ["SIM connectivity issues", "Not connecting to mobile network", "SIM deactivated", "SIM: Replacing Eseye or Hologram"]

export function isSimReplacementFaultType(faultType) {
  return simReplacementFaultTypes.includes(faultType)
}

export function faultTypes() {
  return ["Aborting payments", "Battery not charging", "Battery not holding charge", "Bluetooth not connecting", "Chip reader faulty",
    "Cumulus upgrade", "Device dropped", "Device frozen", "Faulty back cover", "Faulty barcode scanner", "Faulty camera", "Faulty magstripe",
    "Faulty power/volume button", "Keypad button faulty", "Merchant opened device", ...simReplacementFaultTypes,
    "Not resetting", "Not turning on", "Other", "Screen damaged/cracked", "Software update failed", "System error invalid keys",
    "System tamper", "Swollen battery", "Tap functionality not working (NFC)", "Touch screen not working", "Water damaged", "Wifi not working",
    "Protected mode", "Yoco keys not loading", "Upgrade"].sort().map(reason => { return { value: reason, label: reason } })
}

export function provinces() {
  return [
    "Eastern Cape",
    "Free State",
    "Gauteng",
    "KwaZulu-Natal",
    "Limpopo",
    "Mpumalanga",
    "Northern Cape",
    "North West",
    "Western Cape"
  ]
}


// TODO - (shop): Look into receiving payment methods dynamically
export const PAYMENT_METHODS = ["EFT", "Free"]

export const ProductType = {
  CARD_MACHINE: 'card_machine',
  SIM_CARD: 'sim_card',
  ACCESSORY: 'accessory',
  POINT_OF_SALE: 'point_of_sale'
}

export const CountryCode = {
  EG: 'eg',
  ZA: 'za',
}

export function debounce(func, delay) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func(...args);
    }, delay);
  };
}